import { put, takeLatest, select } from "redux-saga/effects";
import { profileActions } from "src/store/profile/profile.actions";
import { backendUrl } from "src/config";
import qs from "qs";
import { authActions } from "../auth/auth.actions";
import { getPrognosisRegistrationConfig as getPrognosisRegistrationConfigSelctor } from "src/store/profile/profile.selectors";
import axiosInstance from "src/axios-instance";

function* getHelptexts() {
  try {
    const texts = yield axiosInstance
      .request({
        method: "GET",
        url: `${backendUrl}/api/external/texts`,
        withCredentials: true
      })
      .then(({ data: { texts } }) => texts);

    yield put(profileActions.fetchHelptextsSuccess({ data: texts }));
  } catch (error) {
    console.error(error);
  }
}

function* getProfile() {
  try {
    const profile = yield axiosInstance.request({
      method: "GET",
      url: `${backendUrl}/api/profile`,
      withCredentials: true
    });

    yield put(profileActions.fetchSuccess({ profile: profile.data.profile }));
  } catch (error) {
    yield put(profileActions.fetchFailure({ errorcodes: [] }));
  }
}

function* getHasCattle() {
  try {
    const profile = yield axiosInstance.request({
      method: "GET",
      url: `${backendUrl}/api/profile/has_cattle`,
      withCredentials: true
    });

    yield put(
      profileActions.fetchHasCattleSuccess({
        has_cattle: profile.data.has_cattle.has_cattle === true
      })
    );
  } catch (error) {
    yield put(profileActions.fetchHasCattleFailure({ errorcodes: [] }));
  }
}

function* getIsSuperuser() {
  try {
    const profile = yield axiosInstance.request({
      method: "GET",
      url: `${backendUrl}/api/profile/is_superuser`,
      withCredentials: true
    });

    yield put(
      profileActions.fetchIsSuperuserSuccess({
        is_superuser: profile.data.is_superuser === true
      })
    );
  } catch (error) {
    yield put(profileActions.fetchIsSuperuserFailure({ errorcodes: [] }));
  }
}

function* getPrognosisRegistrationConfig(action) {
  try {

    const config = yield axiosInstance.request({
      method: "GET",
      url: `${backendUrl}/api/external/prognosis_registration_config`,
      withCredentials: true
    });

    yield put(
      profileActions.fetchPrognosisRegistrationConfigSuccess({
        config: { ...config.data.prognosis_config },
        showPopupNow: action?.payload?.rightAfterLogin &&  !!["pigs","sheep","cattle"].find(animal_kind => config.data.prognosis_config[animal_kind].show_survey),
      })
    );
  } catch (error) {
    console.error(error);
    yield put(
      profileActions.fetchPrognosisRegistrationConfigFailure({ errorcodes: [] })
    );
  }
}
function* getPrognosisSubmitted(action) {
  try {
    const prognosisConfig = yield select(getPrognosisRegistrationConfigSelctor);
    const prognosisData = yield axiosInstance.request({
      method: "GET",
      url: `${backendUrl}/api/prognosis_data?action=get_submitted&prognosis_config_json=${encodeURIComponent(JSON.stringify(
        prognosisConfig.config
      ))}`,
      withCredentials: true
    });

    yield put(
      profileActions.fetchPrognosisSubmittedSuccess({
        data: prognosisData.data.prognosisData
      })
    );
  } catch (error) {
    yield put(profileActions.fetchPrognosisSubmittedFailure({ errorcodes: [] }));
  }
}


function* getPrognosisStatistics(action) {
  try {
    const animalKind = action.payload.animalKind;
    const prognosisConfig = yield select(getPrognosisRegistrationConfigSelctor);
    const prognosisData = yield axiosInstance.request({
      method: "GET",
      url: `${backendUrl}/api/prognosis_data?action=get_statistics&animal_kind=${animalKind}&prognosis_config_json=${encodeURIComponent(JSON.stringify(
        prognosisConfig.config
      ))}`,
      withCredentials: true
    });

    yield put(
      profileActions.fetchPrognosisStatisticsSuccess({
        data: prognosisData.data.prognosisData,
        animalKind: animalKind
      })
    );
  } catch (error) {
    yield put(profileActions.fetchPrognosisStatisticsFailure({ errorcodes: [] }));
  }
}


function* savePrognosis(action) {
  try {
    const prognosisConfig = yield select(getPrognosisRegistrationConfigSelctor);
    const registerPrognosis = yield axiosInstance.request({
      method:"POST",
      url: `${backendUrl}/api/register_prognosis`,
      data: {
        data: action.payload.data,
        prognosis_config: prognosisConfig.config
      },
      withCredentials: true
    });
    action.payload.onSuccess();

    yield put(profileActions.registerPrognosisSuccess({}));
  } catch (error) {
    yield put(profileActions.registerPrognosisFailure({ errorcodes: [] }));
  }
}

function* saveProfile(action) {
  try {
    const profile = yield axiosInstance.request({
      method: "PUT",
      url: `${backendUrl}/api/profile`,
      data: qs.stringify({
        ...action.payload.profile
      }),
      withCredentials: true
    });
    if (action.payload.onSuccess) {
      action.payload.onSuccess();
    }
    yield put(
      profileActions.saveSuccess({
        new_changed_fields: { ...action.payload.profile }
      })
    );
  } catch (error) {
    yield put(profileActions.saveFailure({ errorcodes: [] }));
  }
}

export default [
  takeLatest(profileActions.fetchHelptexts().type, getHelptexts),
  takeLatest(profileActions.fetch().type, getProfile),
  takeLatest(profileActions.save().type, saveProfile),
  takeLatest(profileActions.fetchHasCattle().type, getHasCattle),
  takeLatest(profileActions.fetchIsSuperuser().type, getIsSuperuser),
  takeLatest(
    profileActions.fetchPrognosisRegistrationConfig().type,
    getPrognosisRegistrationConfig
  ),
  takeLatest(profileActions.fetchPrognosisSubmitted().type, getPrognosisSubmitted),
  takeLatest(profileActions.fetchPrognosisStatistics().type, getPrognosisStatistics),
  takeLatest(profileActions.registerPrognosis().type, savePrognosis),
  takeLatest(authActions.loginSuccess().type, getPrognosisRegistrationConfig, {payload: {rightAfterLogin: true}})
];
